const generateHeaders = (title = '', router = '') => {
  let headers = [
    { text: title, value: 'title', width: '26%' },
    { text: 'Độ ưu tiên', value: 'rank', width: '10%' },
    { text: 'Ghi chú', value: 'note', width: '24%' },
    { text: 'Thao tác', align: 'center', value: 'action', width: '10%' }
  ]
  if (router !== 'main') {
    const addedHeaders = [{ text: 'Áp dụng với khoản phí thu/đóng', value: 'salary_head_apply.title', width: '26%' }]
    if (router === 'adjust') addedHeaders.push({ text: 'Loại', value: 'type', width: '10%' })
    headers.splice(2, 0, ...addedHeaders)
  }
  return headers
}

const getTitleFromRouter = (router = '', isSubFee = false) => {
  if (router === 'main') return 'Thành phần lương'
  if (router === 'adjust') return 'Khoản điều chỉnh'
  if (isSubFee) return 'Khoản truy thu'
  return 'Khoản hoàn trả'
}

export const getHeaders = (router = '', isSubFee = false) => {
  return generateHeaders(getTitleFromRouter(router, isSubFee), router)
}

export const getTypeFromRouter = (isSubFee = false) => {
  return isSubFee ? 'Thưởng' : 'Phạt'
}
